module.exports = __webpack_public_path__ + "img/prod_item.45e16b30.png";